import React from 'react';
import { PercentIcon, StoreIcon, SmartphoneIcon, GiftIcon } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    icon: PercentIcon,
    title: 'Beneficios Exclusivos',
    description: 'Ahorra en tus compras con descuentos y promociones en comercios afiliados'
  }, {
    icon: StoreIcon,
    title: 'Cientos de Comercios',
    description: 'Accede a una red en constante crecimiento de restaurantes, tiendas y servicios'
  }, {
    icon: SmartphoneIcon,
    title: 'App Móvil',
    description: 'Lleva tu tarjeta digital siempre contigo y descubre ofertas cercanas'
  }, {
    icon: GiftIcon,
    title: '100% Gratuita',
    description: 'Sin costos de inscripción, sin cuotas mensuales, sin cargos ocultos'
  }];
  return <section className="bg-gradient-to-b from-black to-gray-900 py-20 px-6" data-id="element-6">
      <div className="max-w-6xl mx-auto" data-id="element-7">
        {/* Section header */}
        <div className="text-center mb-16" data-id="element-8">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-9">
            Beneficios{' '}
            <span className="bg-gradient-to-r from-yellow-400 to-yellow-200 bg-clip-text text-transparent" data-id="element-10">
              SamboCard
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-11">
            Disfruta de ventajas exclusivas en tu día a día
          </p>
        </div>

        {/* Benefits grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-12">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <div key={index} className="bg-gray-800/50 backdrop-blur-sm border border-yellow-600/20 rounded-xl p-6 hover:border-yellow-600/50 transition-all hover:transform hover:scale-105" data-id="element-13">
                <div className="w-14 h-14 bg-gradient-to-br from-yellow-600 to-yellow-500 rounded-lg flex items-center justify-center mb-4" data-id="element-14">
                  <Icon className="w-7 h-7 text-black" data-id="element-15" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-16">
                  {benefit.title}
                </h3>
                <p className="text-gray-400" data-id="element-17">{benefit.description}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}